import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CVApp from "./CVApp";
import MainApp from "./MainApp";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainApp />} />
        <Route path="/cv" element={<CVApp />} />
      </Routes>
    </Router>
  );
}

export default App;